import React from "react";
import HistoryRow from "./HistoryRow";
import style from "./SideBar.module.css";

import HistoryEndGameTile from "./HistoryEndGameTile";
import HistoryPlayerRequestTile from "./HistoryPlayerRequestTile";
import EndTrialGame from "./EndTrialGame";
import HistoryRowPendingMoves from "./HistoryRowPendingMoves";
import {useTranslation} from "react-i18next";

function History(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'history' });
    const lastStepsMoveCount = props.gameState?.last_step_moves

    // temporarily filter out metaphoric cards
    let lastMoves = props.gameState?.steps.slice(0, lastStepsMoveCount).map((step) => {
        return <HistoryRow
            key={step.id || step.created}
            step={step}
            updateGameState={props.updateGameState}
            cards={props.cards}
            isLastMove={true}
            loginValid={props.loginValid}/>
    })

    // temporarily filter out metaphoric cards
    let nextMoves = props.gameState?.steps.slice(lastStepsMoveCount).map((step) => {
        return <HistoryRow
            key={step.id || step.created}
            step={step}
            updateGameState={props.updateGameState}
            cards={props.cards}
            isLastMove={false}
            loginValid={props.loginValid}/>
    })

    function historyRows() {
        return <>
            <div className={lastMoves.length ? style.historyRowContainerLast : undefined}>
                {lastMoves}
            </div>
            {nextMoves}
        </>
    }

    return (
        <>
            <div className={style.history}>
                {props.gameState?.is_trial_game && <EndTrialGame {...props}/>}
                {(props.gameState?.is_over && !props.gameState?.is_trial_game)&& <HistoryEndGameTile {...props}/>}
                <HistoryPlayerRequestTile {...props}/>
                {props.gameState.steps_count === 0 && <header>{t('historyTitle')}</header>}
                {props.gameState.pending_moves.length > 0 && <HistoryRowPendingMoves
                    gameState={props.gameState}
                    updateGameState={props.updateGameState}
                    isLoginValid={props.loginValid}
                />}
                <div>
                    {props.gameState && historyRows()}
                </div>
            </div>
        </>

    )
}

export default History